// ZIndexManager.js - Centralized z-index management to prevent overlapping components
// Ensures proper layering hierarchy for mobile and desktop components

export default class ZIndexManager {
  static layers = {
    // Base layers (0-99)
    base: 0,
    gameContainer: 1,
    gameCanvas: 1,
    
    // UI layers (100-999)
    topRibbon: 100,
    menuButtons: 200,
    gameUI: 300,
    
    // Overlay layers (1000-9999)
    overlayBackdrop: 1000,
    modalBackdrop: 2000,
    overlayContent: 3000,
    
    // Mobile UI layers (10000-19999)
    mobileSlidePanel: 10000,
    mobileSlideOverlay: 9999,
    mobileBottomSheet: 10100,
    mobileBottomSheetBackdrop: 10099,
    mobileToast: 10200,
    mobileProgressPanel: 10300,
    
    // PWA layers (20000-29999)
    pwaInstallButton: 20000,
    pwaUpdateNotification: 20001,
    
    // System layers (30000+)
    cookieBanner: 30000,
    emergencyOverlay: 99999
  };
  
  static getLayer(layerName) {
    return this.layers[layerName] || 0;
  }
  
  static setElementLayer(element, layerName) {
    if (element && this.layers[layerName] !== undefined) {
      element.style.zIndex = this.layers[layerName];
    }
  }
  
  static createLayeredElement(tagName, layerName, styles = {}) {
    const element = document.createElement(tagName);
    
    // Apply z-index
    element.style.zIndex = this.getLayer(layerName);
    
    // Apply additional styles
    Object.assign(element.style, styles);
    
    return element;
  }
  
  static auditZIndexConflicts() {
    const elements = document.querySelectorAll('*[style*="z-index"], *[class*="z-"]');
    const conflicts = [];
    const usedZIndexes = {};
    
    elements.forEach(element => {
      const computedStyle = window.getComputedStyle(element);
      const zIndex = parseInt(computedStyle.zIndex);
      
      if (!isNaN(zIndex) && zIndex !== 0) {
        if (usedZIndexes[zIndex]) {
          conflicts.push({
            zIndex,
            elements: [usedZIndexes[zIndex], element]
          });
        } else {
          usedZIndexes[zIndex] = element;
        }
      }
    });
    
    return conflicts;
  }
  
  static fixCommonConflicts() {
    console.log('🔧 ZIndexManager: Fixing common z-index conflicts...');
    
    // Fix overlay conflicts
    const overlays = document.querySelectorAll('.overlay');
    overlays.forEach(overlay => {
      overlay.style.zIndex = this.getLayer('overlayContent');
    });
    
    // Fix mobile component conflicts
    const bottomSheets = document.querySelectorAll('.bottom-sheet');
    bottomSheets.forEach(sheet => {
      sheet.style.zIndex = this.getLayer('mobileBottomSheet');
    });
    
    const slidePanels = document.querySelectorAll('.slide-panel');
    slidePanels.forEach(panel => {
      panel.style.zIndex = this.getLayer('mobileSlidePanel');
    });
    
    // Fix PWA conflicts
    const pwaButtons = document.querySelectorAll('#pwa-install-btn, #pwa-update-notification');
    pwaButtons.forEach(btn => {
      if (btn.id === 'pwa-install-btn') {
        btn.style.zIndex = this.getLayer('pwaInstallButton');
      } else {
        btn.style.zIndex = this.getLayer('pwaUpdateNotification');
      }
    });
    
    console.log('✅ ZIndexManager: Common conflicts fixed');
  }
  
  static logLayerHierarchy() {
    console.log('📊 Z-Index Layer Hierarchy:');
    const sortedLayers = Object.entries(this.layers).sort((a, b) => a[1] - b[1]);
    sortedLayers.forEach(([name, value]) => {
      console.log(`  ${value.toString().padStart(5, ' ')}: ${name}`);
    });
  }
}
